module.exports = __webpack_public_path__ + "img/close_with_circle.b3d7c832.svg";